<ng-container *ngIf="!success">
  <img
    [src]="'assets/icones/profile_shopkeeper.svg'"
    alt="ilustrativa de perfil"
    width="162px"
    height="162px"
  />
  <h1>Os dados de contato estão atualizados?</h1>
  <h2>
    Garanta que as informações da loja estejam corretas para receber novidades e
    ofertas especiais diretamente da Omni
  </h2>
  <form [formGroup]="formGroup">
    <div class="floating-label">
      <input
        type="tel"
        formControlName="phone"
        appTelefone
        appOnlyDigitsLengthValidator
        [minLength]="10"
        [maxLength]="15"
        required
        placeholder=" "
        (focus)="clearErrorMessageCelphone()"
      />
      <label for="phone"> Telefone </label>
    </div>
    <div *ngIf="phone.invalid && phone.touched" class="text-danger">
      <span
        *ngIf="
          phone.errors?.invalidPhone ||
          phone.errors?.minlength ||
          phone.errors?.maxlength
        "
      >
        Telefone inválido
      </span>
      <span *ngIf="phone.errors?.required"> Telefone é obrigatório </span>
      <span *ngIf="errorMessageCelphone">
        {{ errorMessageCelphone }}
      </span>
    </div>

    <div class="floating-label">
      <input
        type="text"
        formControlName="email"
        placeholder=" "
        (focus)="clearErrorMessageEmail()"
      />
      <label for="email"> Email </label>
    </div>
    <div *ngIf="email.invalid && email.touched" class="text-danger">
      <span *ngIf="email.errors?.invalidEmail"> Email inválido </span>
      <span *ngIf="email.errors?.required"> Email é obrigatório </span>
      <span *ngIf="errorMessageEmail">
        {{ errorMessageEmail }}
      </span>
    </div>
  </form>

  <button
    class="primary-button"
    [disabled]="
      formGroup?.invalid || loadingCelphone || loadingEmail || loadingSave
    "
    (click)="updateShopkeeper()"
  >
    <ng-container *ngIf="!loadingSave; else loadingTemplateRef">
      Confirmar Dados
    </ng-container>
  </button>

  <ng-template #loadingTemplateRef>
    <div class="lds-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  </ng-template>
</ng-container>

<ng-container *ngIf="success">
  <app-update-shopkeeper-success></app-update-shopkeeper-success>
</ng-container>
